import React from 'react'
import './Services.css'
import Reviews from '../components/Reviews'
import Steps from '../components/Steps'
import { Link } from 'react-router-dom'

function Services() {
  return (
    <div>
      <div className='hero-section'>
        <div className='hero-sub-section'>
          <h1 className='hero-header'>Postpartum Support Doula Services</h1>
          <p className='grey'>Experience expert care for pregnancy with our compassionate pregnancy support and doula services, ensuring a healthy journey for you and your baby.</p>
          <div className='row-justify-content-between'>
            <Link to='/inquiry' className=' button text-decoration-none'>
                Inquire About Services
            </Link>
          </div>
        </div>
        
        <div className='hero-sub-section'>
          <img src={require('../assets/holdingbaby.jpeg')} alt="Hero" style={{width: '100%', height: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '30px'}} />
        </div>
      </div>

      <div>
        <h1 className='header2'>Providing Parents Education and Peace of Mind.</h1>
        <p className='grey'>We are the largest Doula and Newborn Care Specialists. Our careful attention to detail, depth of experience and commitment to families, has made Malaika DOULAS the leading and most trusted doula practice in the community.</p>
      </div>

      <div className='services-row'>
        <div className='services-card'>
            <img src={require('../assets/postpartumdoula.webp')} alt='Postpartum Doula' className='doula-profile'/>
            <h2 className='darkgrey'>Postpartum Doula Support</h2>
            <p className='grey'>Our Postpartum Doulas provide recovery and newborn care assistance after birth. We support families during the healing and bonding phase with practical help and emotional guidance.</p>
        </div>

        <div className='services-card'>
            <img src={require('../assets/breastfeedingdoula.jfif')} alt='Breastfeeding Doula' className='doula-profile'/>
            <h2 className='darkgrey'>Breastfeeding Doula Support</h2>
            <p className='grey'>Our Breastfeeding Doulas offer lactation guidance and encouragement to nursing parents. We provide practical tips and emotional support throughout your breastfeeding journey.</p>
        </div>

        <div className='services-card'>
            <img src={require('../assets/siblingdoulasupport.jfif')} alt='Sibling Doula' className='doula-profile'/>
            <h2 className='darkgrey'>Sibling Doula Support</h2>
            <p className='grey'>Our Sibling Doulas help older children adjust to the arrival of a new baby. We provide emotional support and preparation to ensure a smooth transition for the whole family.</p>
        </div>
      </div>

      <div className='services-row-2'>

        <div className='services-card'>
            <img src={require('../assets/sleeptraining.webp')} alt='Sleep Training' className='doula-profile'/>
            <h2 className='darkgrey'>Sleep Training</h2>
            <p className='grey'>Our Sleep Specialists help establish healthy sleep routines for your newborn. We guide families through evidence-based techniques for better rest and family well-being.</p>
        </div>
      </div>

      <Reviews /> 
      <Steps />

    </div>
  )
}

export default Services